import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { connect } from "react-redux";
import ShippedOrdersTable from "./ShippedOrdersTable";
import PaidOrdersTable from "./PaidOrdersTable";
import NewOrdersTable from "./NewOrdersTable";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    position: "absolute",
    left: 10,
    right: 10,
  },
}));

function TableSelector(props) {
  const classes = useStyles();

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const displayTable = () => {
    switch (value) {
      case 0:
        return <NewOrdersTable />;
      case 1:
        return <PaidOrdersTable />;
      case 2:
        return <ShippedOrdersTable />;
      case 3:
        return null;
      default:
        return null;
    }
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color={"transparent"}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          variant={"fullWidth"}
          indicatorColor={"primary"}
        >
          <Tab label="New" />
          <Tab label="Paid" />
          <Tab label="Shipped" />
        </Tabs>
      </AppBar>
      {displayTable()}
    </div>
  );
}

// Gets props from the redux store
const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(TableSelector);



// WEBPACK FOOTER //
// ./src/components/tables/TableSelector.js